import React from 'react'

type Props = { className?: string }

export const CatalogIcon: React.FC<Props> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M4 6a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v12H6a2 2 0 0 1-2-2V6z" />
    <path d="M13 6a2 2 0 0 1 2-2h5v14a2 2 0 0 1-2 2h-5V6z" opacity=".7" />
  </svg>
)

export const StoryIcon: React.FC<Props> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M4 5h12a3 3 0 0 1 3 3v11l-4-2-4 2-4-2-4 2V8a3 3 0 0 1 3-3z" />
  </svg>
)

export const NewsIcon: React.FC<Props> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M5 4h11a2 2 0 0 1 2 2v11a3 3 0 0 0-3-3H5V4z" />
    <path d="M3 7h13v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" opacity=".7" />
  </svg>
)

export const ShopIcon: React.FC<Props> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M3 9h18l-2 11H5L3 9z" />
    <path d="M7 9l2-4h6l2 4" opacity=".7" />
  </svg>
)

export const ContactIcon: React.FC<Props> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-5 4V6z" />
  </svg>
)

export const CartIcon: React.FC<Props> = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM3 4h3l2 10h10l2-6H8" />
  </svg>
)

export const localeColor = (id: string) => {
  switch (id) {
    case 'catalog': return 'text-amber-600'
    case 'taste': return 'text-orange-600'
    case 'why-caladinhos': return 'text-teal-600'
    case 'who-we-are': return 'text-violet-600'
    case 'story': return 'text-rose-600'
    case 'news': return 'text-sky-600'
    case 'shop': return 'text-emerald-600'
    case 'contact': return 'text-indigo-600'
    default: return 'text-neutral-600'
  }
}
